<template>
 <div>
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%;" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>

  <div class="sidebar">
   
    <div class="s_left">
      <div class="s_t">
        <div class="ll"></div>
        <div class="lz">新闻资讯</div>
        <div class="ll"></div>
      </div>
      <div class="lll"></div>
      <div class="ttl">
        <div class="ttl_l"></div>

        <img style="width: 18px;margin-left: 26px;height: 18px;display: block;"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x11.png" alt=""></img>
        <div class="n">新闻动态</div>
        <img style="width: 10px;margin-left: 64px;height: 12px;display: block;"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x12.png" alt=""></img>
      </div>
    </div>
    <div class="s_r">
      <div class="s_r_t">
        <div class="z_l">新闻动态
          <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x16.png" alt="">
        </div>
        <div class="zr">
          <img style="width: 14px;height: 14px;margin-right: 4px;"
            src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x13.png" alt="">
          首页 > 新闻资讯 > 新闻动态
        </div>
      </div>
           <div style=" 
      width: 1108px;
        display: flex;align-items: center;margin: 0 auto;">
          <div style="flex:1" class="srl">

          </div>
          <div style="width: 8px;
height: 8px; border-radius: 50%;
border: 1px solid #DDDDDD; "></div>
        </div>
      <div class="z">
        <div  @click="goNext(`/xwxq?id=${item.id}`)" v-for="(item,index)  in newsList" :key="index" class="item">
          <div class="i_l">
            <div class="ss">
              <div class="sss">{{ formatDate(item.addTime).day }}</div>
              <div class="ssss">{{ formatDate(item.addTime).year }}.{{ formatDate(item.addTime).month }}</div>
            </div>
          </div>
          <div class="i_line"></div>
          <div class="i_con">
            <div class="ic1 ellipsis">{{item.title}}</div>
            <div class="ic2 ellipsis">
              <img style="width: 15px;height: 12px;margin-right: 4px;" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x15.png" alt="">
              {{ item.readNum||0 }}次
            </div>
            <div class="ic3 twoEllipsis">{{item.introduction}}</div>
          </div>
          <div class="iii">
            <img :src="item.img" alt="">
          </div>
        </div>
      </div>
        <el-pagination class="elapagination" :current-page="page.pageNum"  
        :page-size="page.pageSize" layout="prev, pager, next" :total="page.total"
         @current-change="handleCurrentChange" />
    </div>
  </div>
 </div>
          
</template>

<script>
import { Know } from '@/api/know'
const know = new Know()
import { queryAllArticle } from "@/api/home";
import { DataClient } from '@/api/dataClient'
const dataClient = new DataClient()
import { getDomain } from '@/api/cookies'
import { getSurfaceList, } from "@/api/home"; 

export default {
  name: "NewsDynamic",
  data() {
    return {
      newsList: [      ],
      infoDomain: {},
      imgList:'',
          page: {
        pageSize: 12,
        pageNum: 1,
        total: 0
      },
    };
  },
  created() {
    this.infoDomain = getDomain()
    this.getList()

  },
  methods: {
      /* 每页条数 */
    handleSizeChange(val) {
      this.page.pageSize = val
      this.page.pageNum = 1
      this.getList()
    },
    /* 当前页码 */
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getList()
    },
    async getList() {
   queryAllArticle("", this.page.pageSize, this.page.pageNum).then((res) => {
        this.newsList = res.rows;
        this.page.total = res.total;
      });
       getSurfaceList(11, undefined, this.infoDomain.entrantsType).then((res) => {
        if (res.code == 0) {
          this.imgList = JSON.parse(JSON.stringify(res.msg));
        }
      });
    },
     formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      // 补 0 处理月份
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      // 补 0 处理日期
      const day = String(date.getDate()).padStart(2, '0'); 
      return { year, month, day };
    }
  }

};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 1400px;
    min-height: 920px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .s_left {
    width: 220px;
    height: 173px;
    background: #1D7DF5;
    border-radius: 0px 0px 0px 0px;
        position: sticky;
    /* 距离顶部 0 像素时固定 */
    top: 90px;
    /* 确保元素显示在其他内容上方 */
    z-index: 9; 
    .s_t {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;

      .ll {
        width: 20px;
        height: 1px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
      }

      .lz {

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 22px;
        color: #FFFFFF;
        margin: 0 12px;
      }
    }

    .lll {
      width: 219px;
      height: 0px;
      border: 1px solid #64A4F3;
      margin-top: 24px;
    }

    .ttl {
      margin-top: 9px;
      width: 220px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;

      .ttl_l {
        width: 4px;
        height: 54px;
        background: #F3AE55;
        border-radius: 0px 0px 0px 0px;
      }

      .n {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-left: 10px;
      }

    }
  }

  .s_r {
    width: 1170px;
    background: #FFFFFF;

    .s_r_t {
      width: 100%;
      height: 63px;
      display: flex;
      padding: 15px 30px;
      align-items: center;
      justify-content: space-between;

      .z_l {
        position: relative;
        font-family: DingTalk JinBuTi, DingTalk JinBuTi;
        font-weight: 400;
        font-size: 20px;
        color: #1D7DF5;

        img {
          position: absolute;
          width: 29px;
          height: 27px;
          top: 0;
        }
      }

      .zr {

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        display: flex;
        align-items: center;
      }
    }

    .srl {
      width: 1108px;
      height: 0px;
      border: 1px solid #DDDDDD;
      margin: 0 auto;
    }

    .z {
      padding:20px 30px;

      .item {
        width: 1110px;
        height: 189px;
        border-radius: 0px 0px 0px 0px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
border-bottom: 1px solid #EEEEEE;
        .i_l {
          width: 113px;
          height: 189px;
          border-radius: 0px 0px 0px 0px;
          display: flex;
          justify-content: center;
          align-items: center;

          .ss {
            .sss {
              font-family: PingFang SC, PingFang SC;
              font-weight: bold;
              font-size: 26px;
              color: #333333;
              text-align: center;
            }

            .ssss {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              text-align: center;
            }
          }
        }
        .i_line{
          width: 30px;
height: 1px;
background: #999999;
border-radius: 0px 0px 0px 0px;
        }
.i_con{
 flex:1;
 padding: 10px;
 padding-top: 36px;
 .ic1{
  width: 650px;
font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 18px;
color: #333333; 
 }
 .ic2{
  display: flex;
  margin-top: 13px;
  align-items: center;
 
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #999999; 

 }
 .ic3{
width: 657px;
height: 55px;
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #333333;
line-height: 26px;
margin-top: 10px;
 }
}
 .iii{
           width: 238px;
height: 148px;
border-radius: 10px 10px 10px 10px; 
img{
         width: 238px;
height: 148px;
border-radius: 10px 10px 10px 10px; 
}
          }
        &:hover {
          background: #F8F8F8;

          .i_l {
            background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x17.png');
            background-size: 100% 100%;
            .ss{
              .sss{
                color:#fff;
              }
              .ssss{
                color:#fff;

              }
            }
          }
          .i_line{
            background: #244497;
          }
         

        }
      }
    }
  }
}
.swImg{
  width: 100%;
}
.swImg{
  img{
    width: 100%;
  }

}
</style>